import * as React from 'react';

import MediaQuery from 'react-responsive';
import { ICalendarAppState } from '../../redux-state';
import { setToDesktop } from '../../redux-state/actions/calendar-settings.actions';
import { connect } from 'react-redux';

interface DispatchToProps {
    setToDesktop: () => void;
}

type ResponsiveProps = DispatchToProps;

export class DesktopResponsiveBase extends React.Component<ResponsiveProps, any> {

    componentWillMount() {
        this.props.setToDesktop();
    }

    /**
     * No need to render anything, since the lifecycle events handle that stuff.
     */
    render() {
        return null
    }
}

function mapDispatchToProps(dispatch): DispatchToProps {
    return {
        setToDesktop: () => dispatch(setToDesktop())
    }
}

export default connect<null, DispatchToProps>(null, mapDispatchToProps)(DesktopResponsiveBase);